
import Vue from "vue";

export default Vue.extend({
  name: "ToiletBoxListHeader",

  computed: {
    isAdmin(): boolean {
      return this.$auth.role === "admin";
    },
  },
});
